"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Button_1 = __importDefault(require("../common/buttons/Button"));
var ProfilePassword = function (_a) {
    var onSubmit = _a.onSubmit;
    var _b = react_1.useState({}), passwordData = _b[0], setPasswordData = _b[1];
    var changeHandler = function (e) {
        var _a;
        setPasswordData(__assign(__assign({}, passwordData), (_a = {}, _a[e.currentTarget.name] = e.currentTarget.value, _a)));
    };
    return (react_1.default.createElement("div", { className: 'settings-section settings-section-general' },
        react_1.default.createElement("span", { className: 'settings-section__title' }, "Change Password"),
        react_1.default.createElement("div", { className: 'settings-section__rows' },
            react_1.default.createElement("div", { className: 'settings-section__row flex flex-row flex-space-between' },
                react_1.default.createElement("label", null, "Old Password"),
                react_1.default.createElement("input", { type: 'password', name: 'oldPassword', placeholder: 'Old Password', value: passwordData.oldPassword, onChange: changeHandler })),
            react_1.default.createElement("div", { className: 'settings-section__row flex flex-row flex-space-between' },
                react_1.default.createElement("label", null, "New Password (Min 8 Characters)"),
                react_1.default.createElement("input", { type: 'password', name: 'newPassword', placeholder: 'New Password (Min 8 Characters)', value: passwordData.newPassword, onChange: changeHandler })),
            react_1.default.createElement("div", { className: 'settings-section__row flex flex-row flex-space-between' },
                react_1.default.createElement("label", null, "Confirm Password"),
                react_1.default.createElement("input", { type: 'password', name: 'confirmPassword', placeholder: 'Confirm Password', value: passwordData.confirmPassword, onChange: changeHandler }))),
        react_1.default.createElement(Button_1.default, { title: 'Change Password', onClick: function () { return onSubmit(passwordData); } }, "Change Password")));
};
exports.default = ProfilePassword;
